<pas-page-wrapper [hasNavbar]="true" [hasFooter]="false">
  <pas-content-wrapper [hasNavbar]="true">
    <!--
      ⚡️⚡️⚡️ ugliest thing ever, but every now and then I have issues with getting the router-outlet rendered. that's why the following line
      will keep it unless component properly fixed (component refactored)
    -->
    <div>&nbsp;</div>

    <router-outlet></router-outlet>
  </pas-content-wrapper>
</pas-page-wrapper>
